export default __webpack_public_path__ + "static/media/search.232aac29.svg";